import { useEffect } from 'react';
import { useActingProviderStore } from '@/store/actingProviderStore';
import { useAuthStore } from '@/store/authStore';
import { connectRealtime, disconnectRealtime, getRealtimeSocket } from '@/lib/realtime';

/** Mantém o socket realtime conectado enquanto houver sessão. Use uma vez no topo. */
export function useRealtimeConnection() {
  const token = useAuthStore((state) => state.token);
  const actingProviderId = useActingProviderStore((state) => state.acting?.providerId ?? null);

  useEffect(() => {
    if (!token) {
      disconnectRealtime();
      return;
    }
    connectRealtime(token);
    return () => {
      // não desconecta no unmount de telas — só ao perder a sessão (token null).
    };
  }, [token, actingProviderId]);
}

/**
 * Assina um evento realtime enquanto o componente está montado. Trocar o foco
 * troca o socket (outra sala), então a assinatura é refeita no novo.
 */
export function useRealtimeEvent<T = unknown>(
  event: string,
  handler: (payload: T) => void,
  enabled = true,
) {
  const token = useAuthStore((state) => state.token);
  const actingProviderId = useActingProviderStore((state) => state.acting?.providerId ?? null);

  useEffect(() => {
    if (!enabled || !token) return;
    const socket = connectRealtime(token) ?? getRealtimeSocket();
    if (!socket) return;
    socket.on(event, handler);
    return () => {
      socket.off(event, handler);
    };
  }, [event, handler, enabled, token, actingProviderId]);
}
